import { useEffect, useState } from 'react';
import './TestimonialCarousel.css';
import { FaStar } from 'react-icons/fa';

function TestimonialCarousel() {
  const testimonials = [
    {
      name: 'Kritika Srivastava',
     
      text: `Hanish Sir is an expert in his field and possesses great knowledge. He is an astrologer with a clear vision and understands others' needs to give appropriate solutions.`,
    },
    {
      name: 'Ravi Deshmukh',
   
      text: `I had an amazing consultation with Acharya Ganesh. His way of explaining things made me trust astrology even more.`,
    },
    {
      name: 'Meena Sharma',
      
      text: `His readings were accurate and helpful in making life decisions. Highly recommended for deep astrological insights.`,
    },
    {
      name: 'Aarav Mehta',
    
      text: `Very knowledgeable and professional. Loved the experience and how personalized the guidance was.`,
    },
    {
      name: 'Nikita Rao',
     
      text: `Truly the best astrologer online. His insights helped me find clarity in career and relationships.`,
    },
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const visibleTestimonials = testimonials
    .slice(index, index + 3)
    .concat(index + 3 > testimonials.length ? testimonials.slice(0, (index + 3) % testimonials.length) : []);

  return (
    <div className="testimonial-section">
        
          <h2 className="section-title">Star Testimonials: A Look Back</h2> 
      <div className="testimonial-carousel">
        
        {visibleTestimonials.map((item, idx) => (
          <div className="testimonial-card" key={idx}>
            
            <h4>{item.name}</h4>
            <p className="testimonial-text">“{item.text}”</p>
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} color="#FFD700" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TestimonialCarousel;
